module.exports = __webpack_public_path__ + "static/img/xt_nl.b3bd685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xt_nl.png
// module id = loX7
// module chunks = 1